module.exports = function isPackageLicensePlate(value) {
    return !!value && !isNaN(value) && (value.length == 10 || value.length==17 || value.length==20);
}
